import { render } from "./selectproduct.html?vue&type=template&id=2fdffae9&scoped=true&external"
import script from "./selectproduct.vue?vue&type=script&lang=js"
export * from "./selectproduct.vue?vue&type=script&lang=js"

import "./selectproduct.vue?vue&type=style&index=0&id=2fdffae9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdffae9"]])

export default __exports__